import { api } from '@/lib/api'

import { ContractorPaymentCycleDetails } from '../types'

export function getPaymentCycleDetails({ id }: { id: string }) {
  return api.get<ContractorPaymentCycleDetails>(
    `/v1/me/payment-cycles/${id}/details`,
  )
}
